/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

import { Component, Input } from "@angular/core";
import { Merchant } from "../../../models";

@Component({
  selector: "app-merchant-address",
  templateUrl: "./merchant-address.component.html"
})
export class MerchantAddressComponent {
  @Input("merchant") merchant!: Merchant;
}
